export const FOOTER_APP_PROMOTION_TEST_IDS = {
    SECTION: 'footer-app-promotion-section',
    QR_CODE: 'footer-app-promotion-qr-code',
    APP_STORE_BUTTON: 'footer-app-promotion-app-store-button',
    GOOGLE_PLAY_BUTTON: 'footer-app-promotion-google-play-button',
} as const;
